import { printVisibility } from '@/features/styles/lib/printStyles';
import { ExperienceImageTypes } from '@/types/gql.generated';
import { Image } from './Image';

export const Logo = () => {
  return (
    <Image
      boxSize={{ base: '80px', md: '120px' }}
      imageType={ExperienceImageTypes.Logo}
      sx={printVisibility.hide()}
    />
  );
};
